/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { WidgetContext } from './widget-context-base';
import { iamLogin } from '../main';
import { iam } from '../iam';
import { WidgetElements } from '../elements/widget-elements-base';

export class BarcodeTotpWidgetContext extends WidgetContext {
  constructor(elements: WidgetElements) {
    super(elements);
  }

  public override initialize() {
    if (iam.settings.debug) console.log('initializing otp qr code widget');
    document.getElementById('dont-have-a-mvision').style.display = 'none';
    iamLogin.registerLocalizationCallback(() => {
      iamLogin.localizeElement('sub-header', 'otpAppSetup');
      iamLogin.localizeElement(document.querySelector('.scan-instructions-details p'), 'otpAppBarcode');
    }, true, true);
    iamLogin.page.showCommonFields(['auth-footer']);
    iamLogin.page.initializeCommon();
  }
}
